import { OrderShipmentGroup } from './order-shipment-group';

export class OrderShipmentGroupsList {
  cacheProcessingTime?: Date = null;
  lastCacheProcessingTimeSeconds?: number = null;
  nextCacheProcessingStartedTime?: Date = null;
  lastCacheProcessingError?: string = null;
  missingContentRefreshTime?: Date = null;
  lastMissingContentRefreshError?: string = null;
  maxAllOrderShipments: number = 0;
  totalSGCCount: number = 0;
  totalADEBSCount: number = 0;
  orderShipmentGroups: OrderShipmentGroup[] = [];
}
